import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";
import dayjs from "dayjs";

const CouponServices = {
  getAppicablePackagesWithoutPagination: async (class_id="") => {
    try {
      const response = await axios.get(
        ApiConstants.getAppicablePackagesWithoutPagination + `?class_id=${class_id}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  addCoupon: async (
    couponId,
    couponcode,
    discription,
    discounttype,
    discountvalue,
    maxvalue,
    orderpuchaselvalue,
    applicablepackages,
    nooftimesuse,
    useperuser,
    usereligibility,
    validity
  ) => {
    try {
      const response = await axios.post(
        ApiConstants.addCoupon,
        {
          couponId: couponId,
          couponCode: couponcode,
          description: discription,
          discountType: discounttype,
          discountValue: discountvalue,
          maxValue: maxvalue,
          minOrderPurchaseValue: orderpuchaselvalue,
          applicablePackages: applicablepackages,
          usageLimit: nooftimesuse,
          maxUsageLimitPerUser: useperuser,
          userEligibility: usereligibility,
          validity: validity,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      // Handle API errors here
      throw error;
    }
  },
  getCoupons: async (
    offset,
    limit,
    selectedDiscountType,
    selectedApplicablePackages,
    startDate,
    endDate
  ) => {
    try {
      const queryParams = new URLSearchParams({
        offset: offset,
        limit: limit,
        discountType: selectedDiscountType,
        packages: selectedApplicablePackages,
      });
      if (startDate) {
        queryParams.append("startDate", dayjs(startDate).format("YYYY-MM-DD"));
      } else {
        queryParams.append("startDate", "");
      }
      if (endDate) {
        queryParams.append("endDate", dayjs(endDate).format("YYYY-MM-DD"));
      } else if (startDate && !endDate) {
        queryParams.append("endDate", dayjs(new Date()).format("YYYY-MM-DD"));
      } else {
        queryParams.append("endDate", "");
      }
      const url = `${ApiConstants.getAllCoupons}?${queryParams.toString()}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateCouponStatus: async (id, status) => {
    try {
      const response = await axios.post(
        ApiConstants.updateCouponStatus,
        {
          id: id,
          is_active: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteCoupon: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteCoupon,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllCouponsWithoutPagination: async (startDate, endDate) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllCouponsWithoutPagination +
          `?startDate=${startDate||""}&endDate=${endDate||""}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default CouponServices;
